import * as React from "react";
import { getAccReadings } from "../../../services/infrastructure/AccService";
import {
  getADataCenter,
  getPowerComponents,
} from "../../../services/datacenter/DatacenterService";
import { IDataCenter, ISearchAcc } from "../../../vm";
import moment from "moment";
import { useParams, useHistory } from "react-router-dom";
import { Loading } from "../../../services/Loading";
import {
  Stack,
  DatePicker,
  DayOfWeek,
  PrimaryButton,
  DefaultButton,
  Breadcrumb,
  IDropdownOption,
  Dropdown,
} from "office-ui-fabric-react";
import { childrenGap } from "../../common/Constants";
import { ToastContext } from "../../common/ToastProvider";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";
import Icon from "@mdi/react";
import { mdiChevronLeft, mdiChevronRight } from "@mdi/js";
import AccTable from "./AccTable";
import WccTable from "./WccTable";
import { getThreshold } from "../../../services/ThresholdService";
import NoDataTile from "../../common/NoDataTile";
import { removeNulls } from "../../../services/UtilService";

export interface AirCooledChillerMainProps { }

const AirCooledChillerMain: React.FC<AirCooledChillerMainProps> = () => {
  //state
  const [state, setState] = React.useState({
    isLoading: false,
    isDatacenterFound: false,
    isAccLoaded: false,
    accSystemList: [],
    accSystemObj: [],
    allCcDropdownList: [],
    datacenter: undefined,
    searchObj: { chillerPlantId: "", datacenterId: "", date: new Date() },
    accReading: [],
    // isAllChecked: false,
    // selectedItems: [],
    threshold: undefined,
  } as {
    isLoading: boolean;
    isDatacenterFound: boolean;
    isAccLoaded: boolean;
    accSystemList: any[];
    accSystemObj: any[];
    allCcDropdownList: IDropdownOption[];
    datacenter?: IDataCenter;
    searchObj: ISearchAcc;
    accReading: any;
    // isAllChecked: boolean;
    // selectedItems: string[];
    threshold?: any;
  });

  //hooks
  const params: any = useParams();
  const history: any = useHistory();
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);

  React.useEffect(() => {
    const asyncFunc = async () => {
      if (params.dataCenterId) {
        getDataCenter(params.dataCenterId);
      }
    };
    asyncFunc();
    // console.log("state", state);
  }, []);

  const getDataCenter = async (datacenterId: string) => {
    setState({ ...state, isLoading: true });
    let result = await getADataCenter(datacenterId);
    // console.log("data center", result.data);
    if (result?.success) {
      setState({
        ...state,
        datacenter: result.data,
        isDatacenterFound: true,
        isLoading: false,
      });
      getThresholdData(result.data);
    } else {
      showToast(result?.message || "Error while getting datacenter", "error");
      setState({
        ...state,
        isDatacenterFound: false,
        isLoading: false,
      });
    }
  };

  const getThresholdData = async (datacenter: IDataCenter) => {
    setState({ ...state, isLoading: true });
    let result = await getThreshold("chiller-plant");
    if (result?.success) {
      getPowerComponentsList(datacenter, result.data.threshold);
    } else {
      showToast(result?.message || "Error while getting datacenter", "error");
      setState({ ...state, isDatacenterFound: false, isLoading: false });
    }
  };

  const getPowerComponentsList = async (
    datacenter: IDataCenter,
    threshold?: any
  ) => {
    setState({ ...state, isLoading: true });
    let result = await getPowerComponents({
      datacenterId: params.dataCenterId,
      types: ["chiller-plant"],
    });
    // console.log("system list", result.data);
    if (result?.success) {
      let options: IDropdownOption[] = [];

      result.data.forEach((ele) => {
        options.push({
          key: ele._id,
          text: ele.name,
          data: {
            chillerType: ele.chillerType,
            chillerCircuitType: ele.chillerCircuitType,
          },
        });
      });
      // console.log(options);

      let obj = {
        ...state,
        accSystemList: result.data,
        isLoading: false,
        datacenter,
        isDatacenterFound: true,
        searchObj: {
          chillerPlantId: options.length > 0 ? (options[0].key as string) : "",
          date: new Date(),
          datacenterId: params.dataCenterId,
          type:
            options.length > 0 && options[0].data?.chillerType
              ? (options[0].data?.chillerType as string)
              : undefined,
          // type:options.length > 0 ? (options[0].data?.chty as string) : undefined,
          // chillerCir:
          circuitType:
            options.length > 0 && options[0].data?.chillerCircuitType
              ? (options[0].data?.chillerCircuitType as string)
              : undefined,
        },
        allCcDropdownList: options,
        threshold,
      };
      setState(obj as any);
      getAccReadingsData(obj);
    } else {
      showToast(
        result?.message || "Error while getting Air-Cooled-Chiller System list",
        "error"
      );
      setState({ ...state, isLoading: false });
    }
  };

  const getAccReadingsData = async (paramState?: any) => {
    let localState = { ...state };
    if (paramState != null) {
      localState = { ...paramState };
    }

    setState({ ...localState, isLoading: true });
    let obj = { ...localState.searchObj };
    obj.date = moment(obj.date).format("YYYY-MM-DD");
    obj = removeNulls(obj);

    // if (obj.type === "water") {
    //   obj.type = "water";
    //   if (obj.circuitType === "single") {
    //     obj.circuitType = "single";
    //   } else {
    //     obj.circuitType = "double";
    //   }
    // } else if (obj.type === "air") {
    //   obj.type = "air";
    //   obj.circuitType = undefined;
    // } else {
    //   obj.type = undefined;
    //   obj.circuitType = undefined;
    // }
    let result = await getAccReadings(obj);
    // console.log("data", result.data);
    if (result?.success) {
      setState({
        ...localState,
        accReading: result.data,
        isLoading: false,
        isAccLoaded: true,
      });
    } else {
      showToast(
        result?.message || "Error while getting Air-Cooled-Chiller readings",
        "error"
      );
      setState({ ...state, isLoading: false, isAccLoaded: false });
    }
  };

  const onSearch = async () => {
    if (!state.searchObj.chillerPlantId) {
      showToast("Please select a chiller plant before searching", "error");
    }
    getAccReadingsData();
  };

  const onNextOrPrevFunc = (isPrev: boolean) => {
    let localState = { ...state };

    let currentSelectedChiller = localState.searchObj.chillerPlantId;
    let currentCCList = localState.allCcDropdownList;

    let currentIndex = currentCCList.findIndex(
      (d) => d.key === currentSelectedChiller
    );

    if (isPrev) {
      if (currentIndex !== 0) {
        localState = {
          ...localState,
          searchObj: {
            ...localState.searchObj,
            chillerPlantId: currentCCList[currentIndex - 1].key as string,
            type: currentCCList[currentIndex - 1].data.chillerType,
          },
        };
      }
    } else {
      if (currentIndex !== currentCCList.length - 1) {
        localState = {
          ...localState,
          searchObj: {
            ...localState.searchObj,
            chillerPlantId: currentCCList[currentIndex + 1].key as string,
            type: currentCCList[currentIndex + 1].data.chillerType,
          },
        };
      }
    }
    getAccReadingsData(localState as any);
  };

  let type = undefined;
  if (state.accReading.length > 0) {
    type = state.accReading[0].type;
  } else {
    type = state.searchObj.type;
  }

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      {state.isDatacenterFound ? (
        <React.Fragment>
          <Stack>
            <Stack.Item>
              {/* <Text variant="xLarge">Air Cooled Chiller Readings</Text> */}
              <Breadcrumb
                items={[
                  {
                    text: state.datacenter
                      ? state.datacenter.name
                      : "Datacenter",
                    key: "datacenter",
                  },
                  {
                    text: "Infrastructures",
                    key: "infrastructure",
                    onClick: () => {
                      history.goBack();
                    },
                  },
                  {
                    text: "Cooled Chiller Readings",
                    key: "cooled-chiller-readings",
                    isCurrentItem: true,
                  },
                ]}
              />
            </Stack.Item>
          </Stack>
          <br />
          <Stack horizontal horizontalAlign="start">
            <Stack.Item>
              <Stack horizontal wrap tokens={childrenGap}>
                <Stack.Item>
                  <Dropdown
                    placeholder="Select a Chiller Plant"
                    selectedKey={state.searchObj.chillerPlantId}
                    styles={{ dropdown: { width: 200 } }}
                    options={state.allCcDropdownList}
                    onChange={(e, v: IDropdownOption | undefined) => {
                      if (v) {
                        setState({
                          ...state,
                          searchObj: {
                            ...state.searchObj,
                            chillerPlantId: v.key as string,
                            type: v.data?.chillerType || undefined,
                            circuitType:
                              v.data?.chillerCircuitType || undefined,
                          },
                        });
                      }
                    }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <DatePicker
                    firstDayOfWeek={DayOfWeek.Sunday}
                    showMonthPickerAsOverlay={true}
                    value={new Date(state.searchObj.date)}
                    showGoToToday={false}
                    onSelectDate={(date: Date | null | undefined) =>
                      setState({
                        ...state,
                        searchObj: { ...state.searchObj, date: date as Date },
                      })
                    }
                    placeholder="Select a date..."
                    ariaLabel="Select a date"
                    styles={{ root: { width: 200 } }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <PrimaryButton text="Search" onClick={() => onSearch()} />
                </Stack.Item>
              </Stack>
            </Stack.Item>
            {/* <Stack.Item>
              <DefaultButton
                text="Accept"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(true)}
              />
              &nbsp;&nbsp;
              <DefaultButton
                text="Reject"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(false)}
              />
            </Stack.Item> */}
          </Stack>
          <br />
          <Stack horizontal horizontalAlign="space-between" wrap>
            <Stack.Item className="ml-6">
              <span
                onClick={
                  state.allCcDropdownList.length < 1 ||
                    state.allCcDropdownList[0]?.key ===
                    state.searchObj.chillerPlantId
                    ? undefined
                    : () => onNextOrPrevFunc(true)
                }
                className={
                  state.allCcDropdownList.length < 1 ||
                    state.allCcDropdownList[0]?.key ===
                    state.searchObj.chillerPlantId
                    ? "btn-disabled"
                    : "btn-enabled pointer"
                }
              >
                <Icon
                  path={mdiChevronLeft}
                  size={0.9}
                  className="btnIcon"
                  style={{
                    marginBottom: -6,
                    marginRight: -8,
                    color: "#135c8a",
                  }}
                />
                <DefaultButton
                  text="Previous Chiller"
                  className="borderless-btn"
                // disabled={
                //     state.allCcDropdownList[0]?.key ===
                // state.searchObj.chillerPlantId
                //   }
                // onClick={() => {
                //   onNextOrPrevFunc(true);
                // }}
                />
              </span>
              <span className="nxt-prv-btn-border"></span>
              <span
                onClick={
                  state.allCcDropdownList.length < 1 ||
                    state.allCcDropdownList[state.allCcDropdownList.length - 1]
                      ?.key === state.searchObj.chillerPlantId
                    ? undefined
                    : () => onNextOrPrevFunc(false)
                }
                className={
                  state.allCcDropdownList.length < 1 ||
                    state.allCcDropdownList[state.allCcDropdownList.length - 1]
                      ?.key === state.searchObj.chillerPlantId
                    ? "btn-disabled"
                    : "btn-enabled pointer"
                }
              >
                <DefaultButton
                  text="Next Chiller"
                  // disabled={
                  // state.allCcDropdownList[state.allCcDropdownList.length - 1]
                  // ?.key === state.searchObj.chillerPlantId
                  // }
                  // onClick={() => {
                  //   onNextOrPrevFunc(false);
                  // }}
                  className="borderless-btn"
                />
                <Icon
                  path={mdiChevronRight}
                  size={0.9}
                  className="btnIcon"
                  style={{ marginBottom: -6, marginLeft: -8, color: "#135c8a" }}
                />
              </span>
            </Stack.Item>
            {/* <Stack.Item>
              <DefaultButton
                text="Accept"
                className="mr-8 custom-secondary-btn"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(true)}
              />
              <DefaultButton
                text="Reject"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(false)}
                className="custom-secondary-btn"
              />
            </Stack.Item> */}
          </Stack>
          <br />
          {state.isAccLoaded && type === undefined && (
            <NoDataTile
              title="No Data found"
              description="No Data added for that particular Cooled Chiller or Date"
            />
          )}

          {state.isAccLoaded && type === "air" && (
            <AccTable
              accReading={state.accReading}
              threshold={state.threshold}
            />
          )}

          {state.isAccLoaded && type === "water" && (
            <WccTable
              accReading={state.accReading}
              threshold={state.threshold}
            />
          )}

          {/* {type != undefined && ( */}
          {/* <div className="next-prev-btn">
            <div>
              <DefaultButton
                text="Previous Chiller"
                className="mr-8"
                disabled={
                  state.allCcDropdownList[0]?.key ===
                  state.searchObj.chillerPlantId
                }
                onClick={() => {
                  onNextOrPrevFunc(true);
                }}
              />
              <DefaultButton
                text="Next Chiller"
                disabled={
                  state.allCcDropdownList[state.allCcDropdownList.length - 1]
                    ?.key === state.searchObj.chillerPlantId
                }
                onClick={() => {
                  onNextOrPrevFunc(false);
                }}
              />
            </div>
          </div> */}
          {/* )} */}

          {/* {state.isAccLoaded && (
            <Stack>
              <div className="office-table bg-white">
                <table className="ms-Table bordered-table w-100">
                  <thead>
                    <tr>
                      <th rowSpan={3}>
                        <Checkbox
                          checked={state.isAllChecked}
                          onChange={(eve, checked) =>
                            onSelectAll(checked as boolean)
                          }
                        />
                      </th>
                      <th rowSpan={3}>Time in Hrs</th>
                      <th rowSpan={3}>Voltage</th>
                      <th rowSpan={3}>Total Current</th>
                      <th rowSpan={3}>Load Chiller</th>
                      <th rowSpan={3}>Load Auxiliary</th>
                      <th rowSpan={3}>Sec. Pump VFD Speed</th>
                      <th rowSpan={3}>Set Point</th>
                      <th rowSpan={3}>Ambient Air</th>
                      <th rowSpan={3}>Internal Ambient</th>
                      <th rowSpan={3}>Outside Ambient</th>
                      <th rowSpan={3}>CHW LWT</th>
                      <th rowSpan={3}>CHW EWT</th>
                      <th rowSpan={3}>T</th>
                      <th rowSpan={3}>VSD Base Plate Temp(T1)</th>
                      <th rowSpan={3}>VSD Base Plate Temp(T2)</th>
                      <th rowSpan={3}>Start Time</th>
                      <th rowSpan={3}>End Time</th>
                      <th rowSpan={3}>Shift Tech Sign</th>
                      <th rowSpan={3}>Status</th>
                      <th rowSpan={3}>Remarks</th>
                      <th rowSpan={3}>Actions</th>
                      {state.accSystemObj !== [] &&
                        state.accSystemObj.map((item) => (
                          <th colSpan={21}>{item.name}</th>
                        ))}
                    </tr>
                    <tr>
                      {state.accSystemObj !== [] &&
                        state.accSystemObj.map((item) => (
                          <>
                            <th colSpan={4}>PRESSURE</th>
                            <th colSpan={8}>TEMPERATURE</th>
                            <th colSpan={9}></th>
                          </>
                        ))}
                    </tr>
                    <tr>
                      {state.accSystemObj !== [] &&
                        state.accSystemObj.map((item) => (
                          <>
                            <th>Oil</th>
                            <th>Discharge</th>
                            <th>Suction</th>
                            <th>COND. Liquid</th>
                            <th>EDUCTOR</th>
                            <th>Discharge</th>
                            <th>COND. Liquid</th>
                            <th>COND. SubCooling</th>
                            <th>COND. Saturated</th>
                            <th>Discharge Super Heat</th>
                            <th>Discharge Saturated</th>
                            <th>Motor TEMP</th>
                            <th>Compressor Speed</th>
                            <th>Flash Tank Level</th>
                            <th>Economizer</th>
                            <th>COND. Drain Valve</th>
                            <th>COND. VSD Fan On</th>
                            <th>COND. VSD Fan Speed</th>
                            <th>Compressor Ampere</th>
                            <th>No. Of Hours</th>
                            <th>No. Of Start</th>
                          </>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {EVEN_SHIFT.map((ele, index) => {
                      let item = state.accReading.find(
                        (e) => e.shiftTime === ele
                      );
                      return (
                        <tr key={index}>
                          <th>
                            <Checkbox
                              disabled={!item || item.status !== "submitted"}
                              checked={state.selectedItems.includes(
                                item?._id as string
                              )}
                              onChange={() =>
                                onIndividualSelect(item?._id as string)
                              }
                            />
                          </th>
                          <th>{ele}</th>
                          <td>{item?.voltage || ""}</td>
                          <td>{item?.totalCurrent || ""}</td>
                          <td>{item?.loadChiller || ""}</td>
                          <td>{item?.loadAuxiliary || ""}</td>
                          <td>{item?.SECPumpVFDSpeed || ""}</td>
                          <td>{item?.setPoint || ""}</td>
                          <td>{item?.ambientAir || ""}</td>
                          <td>{item?.internalAmbient || ""}</td>
                          <td>{item?.outsideAmbient || ""}</td>
                          <td>{item?.chwLwt || ""}</td>
                          <td>{item?.chwEwt || ""}</td>
                          <td>{item?.deltaT || ""}</td>
                          <td>{item?.VSDBasePlateTempT1 || ""}</td>
                          <td>{item?.VSDBasePlateTempT2 || ""}</td>
                          <td>
                            {item?.startTime
                              ? moment(item?.startTime).format("HH:MM")
                              : ""}
                          </td>
                          <td>
                            {item?.endTime
                              ? moment(item?.endTime).format("HH:MM")
                              : ""}
                          </td>
                          <td>{item?.recordedBy || ""}</td>
                          <td>
                            {item && item.status ? UPS_STATUS[item.status] : ""}
                          </td>
                          <td>{item?.remark || ""}</td>
                          <td>
                            {item && item.status === "submitted" && (
                              <React.Fragment>
                                <TooltipHost
                                  content="Accept"
                                  calloutProps={{ gapSpace: 0 }}
                                >
                                  <span
                                    onClick={() =>
                                      handleAcceptOrReject(
                                        item?._id as string,
                                        true
                                      )
                                    }
                                  >
                                    <Icon
                                      path={mdiCheck}
                                      size={0.8}
                                      className="pointer"
                                      color="green"
                                    />
                                  </span>
                                </TooltipHost>
                                <TooltipHost
                                  content="Reject"
                                  calloutProps={{ gapSpace: 0 }}
                                >
                                  <span
                                    onClick={() =>
                                      handleAcceptOrReject(
                                        item?._id as string,
                                        false
                                      )
                                    }
                                  >
                                    <Icon
                                      path={mdiClose}
                                      size={0.8}
                                      className="pointer"
                                      color="red"
                                    />
                                  </span>
                                </TooltipHost>
                              </React.Fragment>
                            )}
                          </td>
                          {item && item.systems
                            ? item?.systems.map((i) => {
                                let index: number = state.accSystemObj.findIndex(
                                  (e) => e._id === i.chillerPlantId
                                );
                                return (
                                  <>
                                    <td>
                                      {item?.systems[index].pressure.oil || ""}
                                    </td>
                                    <td>
                                      {item?.systems[index].pressure
                                        .discharge || ""}
                                    </td>
                                    <td>
                                      {item?.systems[index].pressure.suction ||
                                        ""}
                                    </td>
                                    <td>
                                      {item?.systems[index].pressure
                                        .condLiquid || ""}
                                    </td>
                                    <td>
                                      {item?.systems[index].temperature
                                        .educator || ""}
                                    </td>
                                    <td>
                                      {item?.systems[index].temperature
                                        .discharge || ""}
                                    </td>
                                    <td>
                                      {item?.systems[index].temperature
                                        .condLiquid || ""}
                                    </td>
                                    <td>
                                      {item?.systems[index].temperature
                                        .condSubCooling || ""}
                                    </td>
                                    <td>
                                      {item?.systems[index].temperature
                                        .condSaturated || ""}
                                    </td>
                                    <td>
                                      {item?.systems[index].temperature
                                        .dischargeSuperHeat || ""}
                                    </td>
                                    <td>
                                      {item?.systems[index].temperature
                                        .dischargeSaturated || ""}
                                    </td>
                                    <td>
                                      {item?.systems[index].temperature
                                        .motorTemp || ""}
                                    </td>
                                    <td>
                                      {item?.systems[index].compressorSpeed ||
                                        ""}
                                    </td>
                                    <td>
                                      {item?.systems[index].flashTankLevel ||
                                        ""}
                                    </td>
                                    <td>
                                      {item?.systems[index].economizer || ""}
                                    </td>
                                    <td>
                                      {item?.systems[index].condDrainValue ||
                                        ""}
                                    </td>
                                    <td>
                                      {item?.systems[index].condVSDFanOn || ""}
                                    </td>
                                    <td>
                                      {item?.systems[index].condVSDFanSpeed ||
                                        ""}
                                    </td>
                                    <td>
                                      {item?.systems[index].compressorAmpere ||
                                        ""}
                                    </td>
                                    <td>
                                      {item?.systems[index].noOfHours || ""}
                                    </td>
                                    <td>
                                      {item?.systems[index].noOfStarts || ""}
                                    </td>
                                  </>
                                );
                              })
                            : state.accSystemObj !== [] &&
                              state.accSystemObj.map((item) => (
                                <>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                </>
                              ))}
                          {state.accSystemObj &&
                            state.accSystemObj.length > 0 &&
                            item?.systems &&
                            item?.systems.length > 0 &&
                            state.accSystemObj.map((ele) => {
                              let index: any = item?.systems.findIndex(
                                (e) => e.chillerPlantId === ele._id
                              );
                              if (index !== -1) {
                                return (
                                    <>
                                  <td> {item?.systems[index].pressure.oil} </td>
                                  <td> {item?.systems[index].pressure.oil} </td>
                                  <td> {item?.systems[index].pressure.oil} </td>
                                  <td> {item?.systems[index].pressure.oil} </td>
                                  </>
                                );
                              } else {
                                return <td></td>;
                              }
                            })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </Stack>
          )} */}
        </React.Fragment>
      ) : (
        <NoDataTile
          title="No Datacenter Found"
          description="Datacenter either deleted or not created"
        />
      )}
    </React.Fragment>
  );
};

export default AirCooledChillerMain;
